import MetricChart from "./MetricChart";
import { endpoints } from "../../helpers/Endpoints";

export default function SchoolPaymentMetrics() {
  return (
    <MetricChart
      title="School Payment Metrics"
      endpoint={endpoints.getSchoolPaymentMetrics}
      queryParamKey="status"
      datasetMap={{
        all: 'ALL',
        pending: 'PENDING',
        successful: 'SUCCESSFUL',
        failed: 'FAILED',
        initiated: 'INITIATED'
      }}
    />
  );
}
